module.exports = __webpack_public_path__ + "static/img/yundianliang.48219f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yundianliang.png
// module id = 4ETv
// module chunks = 1